import { Brand, Program } from '..';

const StayzPrograms: Record<string, Program> = {
  'au-stayz': {
    id: 'au-stayz',
    name: 'Stayz AU',
    brand: Brand.STAYZ,
    posa: 'AU',
    currency: 'AUD',
    locale: {
      baseName: 'en_AU',
      langId: 3081,
    },
  },
};

export { StayzPrograms };
